module.exports = __webpack_public_path__ + "img/bg3.ab12f6c4.svg";